// Video
import React, { useRef, useState } from 'react';
import styles from './Video.module.sass';
import cn from 'classnames';
import Icon from '../Icon';

export interface VideoProps
  extends React.DetailedHTMLProps<
    React.VideoHTMLAttributes<HTMLVideoElement>,
    HTMLVideoElement
  > {
  className?: string;
  videoClass?: string;
  noPlay?: boolean;
}

const PLACEHOLDER_VIDEO =
  'https://res.cloudinary.com/codelife/video/upload/v1637805738/intro_l5ul1k.mp4';

const Video: React.FC<VideoProps> = ({
  className,
  videoClass,
  src = PLACEHOLDER_VIDEO,
  autoPlay,
  noPlay = false,
  ...props
}) => {
  const isYoutube = src.includes('youtube');
  // FIXME: Play button won't trigger youtube play
  const [showPlay, setShowPlay] = useState<boolean>(!isYoutube && !autoPlay);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlay = () => {
    if (videoRef.current && !noPlay) {
      const video = videoRef.current;
      video.play();
      setShowPlay(false);
    }
  };

  return (
    <div className={cn(styles.videoContainer, className)}>
      {isYoutube ? (
        <iframe
          className={cn(styles.video, videoClass)}
          src={src}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      ) : (
        <video
          ref={videoRef}
          className={cn(styles.video, videoClass)}
          controls={!showPlay}
          src={src}
          autoPlay={autoPlay}
          {...props}
        />
      )}
      {showPlay && (
        <span className={styles.play}>
          <Icon onClick={handlePlay} name="play-video" color="neutral04" />
        </span>
      )}
    </div>
  );
};

export default Video;
